<template>
  <div class="skill__content">
    <p>
      HTML email template creation, compatibility rendering across major mobile
      & desktop email clients.
    </p>
  </div>
</template>
